import Vue from 'vue'
import App from './App'
import store from './store/store'
import router from './router'
import VueMq from 'vue-mq'

// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'

// Vue.use(VueMaterial)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 600.999,
    tablet: 900.999,
    laptop: 1200.9999999999,
    desktop: 1450.999999999,
    large: 1700.999999999,
    xl: Infinity,
  }
})

Vue.config.productionTip = false

// Vue.use(MdField);
// Vue.use(MdInput);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js